module.exports = __webpack_public_path__ + "img/svgicon.df181f37.png";